import React, { useState, useEffect } from "react";
import { Button, Tab, Icon, Container } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  ListAssistance,
  AssistanceForm,
} from "../../../components/Admin/AssistantComp";
import "./Page_Assistant.scss"; // Asegúrate de que este import esté correcto.

export function Page_Assistant() {
  const [showModal, setShowModal] = useState(false);
  const [reload, setReload] = useState(false);
  const [showSteps, setShowSteps] = useState(false); // Controla si se muestran o no los "steps"

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onReload = () => setReload((prev) => !prev);

  // Limpiar localStorage al montar el componente
  useEffect(() => {
    const imageKey = "imageAvatar";
    if (localStorage.getItem(imageKey)) {
      localStorage.removeItem(imageKey);
    }
  }, []);

  // --------------------------------------------------------------------------------
  // Pasos explicativos sobre Asistentes
  // --------------------------------------------------------------------------------
  const steps = [
    {
      title: "Paso 1",
      description:
        'Pulsando “Nuevo Asistente” puedes crear un asistente virtual entrenado con IA para que ayude a tus alumnos por los distintos itinerarios que les asignes en tus clases.',
    },
    {
      title: "Paso 2",
      description:
        "En el proceso de creación tienes que describir quién es y el comportamiento que quieres que tenga ante tus alumnos.",
    },
    {
      title: "Paso 3",
      description:
        "Redacta reglas, ejercicios y objetivos que debe aplicar al ser consultado. Una vez creado, comprueba que tu asistente está preparado para que tus alumnos conversen con él, y recuerda que siempre puedes editar su prompt para mejorar su funcionamiento.",
    },
  ];

  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <ListAssistance reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <Container className="ui-materials assistance-page"> {/* Cambiado a assistance-page para consistencia */}
        {/* -------------------------------------------------------------------------------- */}
        {/* 1) Sección introductoria con título y descripción */}
        {/* -------------------------------------------------------------------------------- */}
        <div className="intro-header"> {/* Clase ajustada */}
          <div className="intro-sections"> {/* Clase ajustada, hereda estilos de Page_UIMaterials.scss */}
            <div className="intro-section rutas-creadas"> {/* Clase ajustada y añadida 'intro-section' */}
              <h2 className="intro-title"> {/* Clase existente en Page_UIMaterials.scss */}
                Aquí tienes los "ASISTENTES IA" que EDUCA360 pone a tu
                disposición para integrarlos en escenas e itinerarios.
              </h2>
              <p className="intro-description"> {/* Clase existente en Page_UIMaterials.scss */}
                Están programados para plantear ejercicios, con alguna pista,
                que el alumnado tendrá que resolver con lo que encuentre en la
                sesión propuesta.
              </p>
              <hr className="intro-divider" /> {/* Clase existente en Page_UIMaterials.scss */}
            </div>
          </div>

          {/** Icono de información que muestra/oculta los pasos */}
          <div
            className="info-toggle" 
            onClick={() => setShowSteps((prev) => !prev)}
            title={showSteps ? "Ocultar información" : "Mostrar información"}
          >
            <Icon name="info" size="large" />
          </div>
        </div>

        {/* -------------------------------------------------------------------------------- */}
        {/* 2) Bloque de pasos (se renderiza solo si showSteps===true) */}
        {/* -------------------------------------------------------------------------------- */}
        {showSteps && (
          <div className="assistant-steps"> 
            {steps.map((s, i) => (
              <div key={i} className="intro-section step"> {/* Clase 'intro-section' y 'step' */}
                <h2 className="intro-title">{s.title}</h2> {/* Usamos 'intro-title' */}
                <p className="intro-description">{s.description}</p> {/* Usamos 'intro-description' y 'description' en el objeto steps */}
                <hr className="intro-divider" /> {/* Usamos 'intro-divider' */}
              </div>
            ))}
          </div>
        )}

        {/* -------------------------------------------------------------------------------- */}
        {/* 3) Botón “Nuevo Asistente IA” */}
        {/* -------------------------------------------------------------------------------- */}
        <div className="assistance-page__add"> {/* Clase ajustada */}
          <Button
            className="assistance-page__add__button" 
            onClick={onOpenCloseModal}
          >
            CREAR ASISTENTE IA
          </Button>
        </div>

        {/* -------------------------------------------------------------------------------- */}
        {/* 4) Lista de asistentes mediante Tab de Semantic UI */}
        {/* -------------------------------------------------------------------------------- */}
        <Tab menu={{ secondary: true }} panes={panes} />
      </Container>

      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nuevo Asistente IA"
        size="large"
      >
        <AssistanceForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}